import React, {useEffect, useState} from 'react'
import './propertyNewHome_styles/propertyNewHome.css'
import FilterDropdown from './FilterDropdown'
import AddNewNewProperty from './AddNewNewProperty'
import {Get_Property_List, All_Property_Report, getAllKYC} from './Property_Api'
import {CircularProgress} from '@mui/material'
import {Link, useNavigate} from 'react-router-dom'
import {propertyDataType, allKYCDataType, reportDataDataType} from './PropertyDataTypes'
import Swal from 'sweetalert2'
import PaginationComponent from '../PaginationComponent/Pagination'
import BulkPropertyUploadModal from './BulkPropertyUploadModal'
import * as XLSX from 'xlsx'
import BulkUtilityUploadModal from './BulkUtilityUploadModal'
import SearchProperty from './SearchProperty'
import {sendWhatsappMessage} from './Property_Api'

function PropertyNewNewHome() {
  const navigate = useNavigate()
  const [apiData, setApiData] = useState<propertyDataType[]>([])
  const [propertyData, setPropertyData] = useState<propertyDataType[]>()
  const [propertyReportDataLoading, setPropertyReportDataLoading] = useState<boolean | undefined>(
    false
  )
  const [showAddPropertyModal, setShowAddPropertyModal] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [noDataFound, setNoDataFound] = useState<boolean>(false)
  const [allKYC, setAllKYC] = useState<allKYCDataType[]>([])
  const [activeKYC, setActiveKYC] = useState<allKYCDataType[]>([])
  const [noKYCFound, setNoKYCFound] = useState<Boolean>(false)
  const [showPropertyBulkUploadModal, setShowPropertyBulkUploadModal] = useState<Boolean>(false)
  const [showUtilityBulkUploadModal, setShowUtilityBulkUploadModal] = useState<Boolean>(false)
  const [searchInputValue, setsearchInputValue] = useState<string>('')
  const [itemOffset, setItemOffset] = useState<number>(0)
  const [dataLength, setDataLength] = useState<number>(0)
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 10
  const pageCount = Math.ceil(dataLength / itemsPerPage)

  // function to get list of all properties
  async function getListAllKYC() {
    try {
      const {data: response} = await getAllKYC()
      if (response.code === '200') {
        setNoKYCFound(false)
        setAllKYC(response.data)
        setActiveKYC(response.data.filter((kyc: any) => kyc.account_kyc_status === 1))
      } else if (response.code === '204') {
        setNoKYCFound(true)
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: response.msg.charAt(0).toUpperCase() + response.msg.slice(1),
          text: response.msg_details,
          allowOutsideClick: true,
        })
      }
    } catch (error: any) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error,
      })
    }
  }

  // function to get properties which are already added
  async function getProperty(searchInputValue: string) {
    setLoading(true)
    try {
      const response = await Get_Property_List(itemOffset, itemsPerPage, searchInputValue)
      if (response.status === 200) {
        if (response.data.data.length !== 0) {
          setNoDataFound(false)
          setApiData(response.data.data.property)
          setPropertyData(response.data.data.property)
          setDataLength(response.data.data.totalProperties)
        } else {
          setNoDataFound(true)
          setDataLength(0)
        }
      } else {
        setNoDataFound(true)
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: response.data.msg.charAt(0).toUpperCase() + response.data.msg.slice(1),
          text: response.data.msg_details,
          allowOutsideClick: true,
        })
      }
    } catch (error: any) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error,
      })
    } finally {
      setLoading(false)
    }
  }

  // function to generate property report
  // async function getListAllKYC() {
  //   try {
  //     const { data: response } = await getAllKYC()
  //     if (response.code === '200') {
  //       setNoKYCFound(false)
  //       setAllKYC(response.data)
  //       setActiveKYC(response.data.filter((kyc: any) => kyc.account_kyc_status === 1))
  //     } else if (response.code === '204') {
  //       setNoKYCFound(true)
  //     } else {
  //       Swal.fire({
  //         position: 'center',
  //         icon: 'error',
  //         title: response.msg.charAt(0).toUpperCase() + response.msg.slice(1),
  //         text: response.msg_details,
  //         allowOutsideClick: true,
  //       })
  //     }
  //   } catch (error: any) {
  //     Swal.fire({
  //       position: 'center',
  //       icon: 'error',
  //       title: error,
  //     })
  //   }
  // }

  // function to get proeprty reports
  async function getPropertyReport() {
    setPropertyReportDataLoading(true)
    try {
      const {data: res} = await All_Property_Report()
      if (res.code === '200') {
        handleGeneratePropertyReport(res.data)
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
          text: res.msg_details,
        })
      }
    } catch (error: any) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error,
      })
    } finally {
      setPropertyReportDataLoading(false)
    }
  }

  useEffect(() => {
    getListAllKYC()
  }, [])
  useEffect(() => {
    getProperty(searchInputValue)
  }, [itemOffset, searchInputValue])

  const handleGeneratePropertyReport = (reportData: reportDataDataType) => {
    const excelfile = XLSX.utils.book_new()
    const header1 = [
      'SL No.',
      'Property Title',
      'Property Type',
      'Carpet Area',
      'Area Unit',
      'Address',
      'Expected Rent(₹)',
      'Realized Rent(₹)',
      'Furnishing Type',
      'Category',
      'No. of Units',
      'Tenant Name',
      'Tenant Email',
      'Tenant Contact No.',
    ]
    const workSheet = XLSX.utils.json_to_sheet(reportData.main, {header: header1})
    const colWidths = [
      {wpx: 40},
      {wpx: 100},
      {wpx: 100},
      {wpx: 80},
      {wpx: 80},
      {width: 20, wch: 20},
      {wpx: 100},
      {wpx: 100},
      {wpx: 100},
      {wpx: 100},
      {wpx: 60},
      {wpx: 100},
      {wpx: 100},
      {wpx: 100},
    ]
    workSheet['!cols'] = colWidths
    XLSX.utils.book_append_sheet(excelfile, workSheet, 'Main')

    var header = [
      'SL NO.',
      'Month',
      'Payment Due Date',
      'Invoice Type',
      'Payment Mode',
      'Paid Amount(₹)',
      'Payment Status',
    ]
    for (const sheet in reportData.transactins) {
      const workSheet = XLSX.utils.json_to_sheet(reportData.transactins[sheet], {header: header})
      const colWidths = [
        {wpx: 40},
        {wpx: 80},
        {wpx: 150},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
        {wpx: 100},
      ]
      workSheet['!cols'] = colWidths
      XLSX.utils.book_append_sheet(excelfile, workSheet, sheet)
    }
    XLSX.writeFile(excelfile, 'All Properties Report.xlsx')
  }

  // routing to tenant page with the following parameters
  const submitTenant = (
    account_role_json: any,
    property_title: string,
    property_usage_type: string,
    sub_unit_available: string,
    property_uuid: string
  ) => {
    navigate('/tenant', {
      state: {
        account_role_json: account_role_json,
        propertytitle: property_title,
        property_usage_type: property_usage_type,
        sub_unit_available: sub_unit_available,
        property_uuid: property_uuid,
      },
    })
  }

  // routing to property user page with the following parameters
  const SubmitPropertyUsers = (
    account_role_json: any,
    property_uuid: any,
    property_title: string,
    property_usage_type: string,
    property_id: any
  ) => {
    navigate(`/propertyUsers/${property_uuid}`, {
      state: {
        account_role_json: account_role_json,
        property_uuid: property_uuid,
        propertytitle: property_title,
        property_usage_type: property_usage_type,
        property_id: property_id,
      },
    })
  }

  // const handleWhatsapp = (property_uuid: string) => {
  //   console.log("property_uuid", property_uuid);
  // }

  async function handleWhatsapp(property_uuid: string) {
    try {
      const {data: res} = await sendWhatsappMessage(property_uuid)
      if (res.code === '200') {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: res.msg,
          text: res.msg_details,
        })
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
          text: res.msg_details,
        })
      }
    } catch (error: any) {}
  }

  return (
    <>
      {/* End: loader */}
      {/* Begin: property page content */}
      <div className='app-main flex-column flex-row-fluid' id='kt_app_main'>
        <div className='d-flex flex-column flex-column-fluid'>
          {/* Begin: header for property page */}
          <div className='d-flex align-items-center gap-2 gap-lg-3 justify-content-between mb-5 px-5 flex-wrap'>
            {/* Begin: Heading */}
            <h1
              className='page-heading d-flex text-dark fw-bold fs-3 my-0
            flex-column justify-content-center'
            >
              Properties
            </h1>
            {/* End: Heading */}
            <div className='d-flex flex-column justify-content-between gap-2'>
              <SearchProperty
                setCurrentPage={setCurrentPage}
                setItemOffset={setItemOffset}
                setsearchInputValue={setsearchInputValue}
                placeholder='Property'
              />
              {/* {!noKYCFound && activeKYC.length > 0 && ( */}
              <div className='d-flex align-items-center gap-2 gap-lg-3 flex-wrap'>
                {/* Begin: Add Property button */}
                <button
                  onClick={() => setShowAddPropertyModal(!showAddPropertyModal)}
                  className='btn btn-sm fw-bold btn-primary'
                >
                  Add New Property
                </button>
                <button
                  type='button'
                  className='btn btn-sm fw-bold btn-primary'
                  onClick={() => setShowPropertyBulkUploadModal(true)}
                >
                  Bulk Property Upload
                </button>
                <button
                  type='button'
                  className='py-1 my-2 btn btn-sm fw-bold btn-primary py-3'
                  onClick={() => setShowUtilityBulkUploadModal(true)}
                >
                  Bulk Utility upload
                </button>
                {!noDataFound && (
                  <button
                    type='button'
                    className='btn btn-sm fw-bold btn-primary'
                    onClick={() => getPropertyReport()}
                    disabled={propertyReportDataLoading}
                  >
                    {propertyReportDataLoading ? (
                      <span className='indicator-progress' style={{display: 'block'}}>
                        Processing...
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    ) : (
                      <span className='indicator-label'>Generate Properties Report</span>
                    )}
                  </button>
                )}

                {showAddPropertyModal && (
                  <>
                    <AddNewNewProperty
                      show={showAddPropertyModal}
                      handleClose={() => setShowAddPropertyModal(false)}
                      getProperty={() => getProperty(searchInputValue)}
                      activeKYC={activeKYC}
                    />
                  </>
                )}
                {showPropertyBulkUploadModal && (
                  <BulkPropertyUploadModal
                    show={showPropertyBulkUploadModal}
                    handleClose={() => setShowPropertyBulkUploadModal(false)}
                    getProperty={() => getProperty(searchInputValue)}
                  />
                )}
                {showUtilityBulkUploadModal && (
                  <BulkUtilityUploadModal
                    show={showUtilityBulkUploadModal}
                    handleClose={() => setShowUtilityBulkUploadModal(false)}
                    refreshTableAPI={() => getProperty(searchInputValue)}
                  />
                )}
                {/* End: Add Property button */}
                {/* {!noDataFound && (
                    <div className=''>
                      {/* Begin: filter button 
                      <button
                        className='btn btn-sm btn-flex btn-light fw-bold bg-color-white'
                        data-kt-menu-trigger='click'
                        data-kt-menu-placement='bottom-end'
                        data-kt-menu-flip='top-end'
                      >
                        Filter
                      </button>
                      <FilterDropdown data={apiData} setPropertyData={setPropertyData} />
                      {/* End: filter button 
                    </div>
                  )} */}
              </div>
            </div>
            {/* )} */}
          </div>
          {/* End: header for property page */}
          {/* Begin: Table */}
          <>
            {loading ? (
              // {* Begin: loader*}
              <div
                className='d-flex justify-content-center align-items-center vh-70'
                style={{height: '70vh'}}
              >
                <CircularProgress />
              </div>
            ) : (
              <>
                <div id='table div'>
                  <div className='card mb-5 mb-xl-8'>
                    <div className='card-body py-3'>
                      <div className='table-responsive'>
                        {/* begin::Table */}
                        <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                          {/* begin::Table head */}
                          {!noDataFound && (
                            <thead>
                              <tr className='fw-bold text-muted'>
                                {/* <th className='w-25px'>
                            <div className='form-check form-check-sm form-check-custom form-check-solid'>
                              <input
                                className='form-check-input'
                                type='checkbox'
                                value='1'
                                data-kt-check='true'
                                data-kt-check-target='.widget-9-check'
                              />
                            </div>
                          </th> */}
                                <th className='max-w-150px'>Property Name</th>
                                <th className='max-w-150px'>Email</th>
                                <th className='max-w-150px'>Contact No</th>
                                <th className='max-w-150px'>Available</th>
                                <th className='max-w-200px'>Details</th>
                                <th className='max-w-100px'>Rent</th>
                                <th className='max-w-50px'>Role</th>
                                <th className='max-w-150px'>Actions</th>
                              </tr>
                            </thead>
                          )}
                          {/* end::Table head */}
                          {/* begin::Table body */}
                          <tbody>
                            {/* {noKYCFound ? (
                          <tr>
                            <td colSpan={5}>
                              <span className='d-flex flex-column align-items-center flex-start p-10'>
                                <img
                                  src='/media/svg/undraw/property.svg'
                                  alt='No document uploaded'
                                  className='h-200px w-200px'
                                />
                                <span className='fw-bold text-muted fs-1 text-center'>
                                  KYC is required to add property
                                </span>
                                <Link
                                  to='/KYC_Details'
                                  className='mt-6 btn btn-sm fw-bold btn-primary'
                                >
                                  Add KYC Account
                                </Link>
                              </span>
                            </td>
                          </tr>
                        ) : !noKYCFound && allKYC.length > 0 && activeKYC.length <= 0 ? (
                          <tr>
                            <td colSpan={5}>
                              <span className='d-flex flex-column align-items-center flex-start p-10'>
                                <img
                                  src='/media/svg/undraw/property.svg'
                                  alt='No document uploaded'
                                  className='h-200px w-200px'
                                />
                                <span className='fw-bold text-muted fs-1 text-center'>
                                  Your KYC is pending verification
                                </span>
                                <Link
                                  to='/KYC_Details'
                                  className='mt-6 btn btn-sm fw-bold btn-primary'
                                >
                                  Add Another KYC Account
                                </Link>
                              </span>
                            </td>
                          </tr>
                        ) :  */}
                            {noDataFound ? (
                              <tr>
                                <td colSpan={5}>
                                  <span className='d-flex flex-column align-items-center flex-start p-10'>
                                    <img
                                      src='/media/svg/undraw/property.svg'
                                      alt='No document uploaded'
                                      className='h-200px w-200px'
                                    />
                                    <span className='fw-bold text-muted fs-1 text-center'>
                                      No properties present
                                    </span>
                                  </span>
                                </td>
                              </tr>
                            ) : (
                              propertyData?.map((property, index: number) => {
                                return (
                                  <tr key={index}>
                                    {/* <td>
                                <div className='form-check form-check-sm form-check-custom form-check-solid'>
                                  <input
                                    className='form-check-input widget-9-check'
                                    type='checkbox'
                                    value='1'
                                  />
                                </div>
                              </td> */}
                                    <td className='max-w-150px'>
                                      <div className='d-flex align-items-center'>
                                        <div className='symbol symbol-45px me-3'>
                                          <span className='symbol symbol-50px me-2'>
                                            <span className='symbol-label bg-light-primary'>
                                              {property.property_img_url ? (
                                                <div className='symbol symbol-50px'>
                                                  <img
                                                    src={property.property_img_url}
                                                    alt='Property icon'
                                                    style={{objectFit: 'cover'}}
                                                  />
                                                </div>
                                              ) : (
                                                <i className='bi bi-house-door fs-2x btn btn-active-color-primary'></i>
                                              )}
                                            </span>
                                          </span>
                                        </div>
                                        <div className='d-flex justify-content-start flex-column'>
                                          <Link
                                            to={`/property/${property.property_uuid}/overview`}
                                            className='text-dark fw-bold text-hover-primary fs-6'
                                            title={
                                              property.property_title.charAt(0).toUpperCase() +
                                              property.property_title.slice(1)
                                            }
                                          >
                                            <div className='text-truncate mw-95px'>
                                              {property.property_title.charAt(0).toUpperCase() +
                                                property.property_title.slice(1)}
                                            </div>
                                          </Link>
                                          <span className='text-muted fw-semibold text-muted d-block fs-7'>
                                            {property.property_type_name}
                                          </span>
                                        </div>
                                      </div>
                                    </td>
                                    <td className='max-w-150px'>
                                      <span className='text-dark fw-bold text-hover-primary d-block fs-6'>
                                        {`${property.email}`}
                                      </span>
                                    </td>
                                    <td className='max-w-100px'>
                                      <span className='text-dark fw-bold text-hover-primary d-block fs-6'>
                                        {`${property.contact_number}`}
                                      </span>
                                    </td>
                                    <td className='max-w-100px'>
                                      <span className='text-dark fw-bold text-hover-primary d-block fs-6'>
                                        {`${property.property_available}`}
                                      </span>
                                    </td>
                                    <td className='max-w-200px'>
                                      <span className='text-muted fw-semibold text-muted d-block fs-7'>
                                        {property.property_address.charAt(0).toUpperCase() +
                                          property.property_address.slice(1)}
                                      </span>
                                    </td>
                                    <td className='max-w-100px'>
                                      <span className='text-dark fw-bold text-hover-primary d-block fs-6'>
                                        {`₹ ${property.current_rent}`}
                                      </span>
                                    </td>
                                    <td className='max-w-60px'>
                                      <span className='text-muted fw-semibold text-muted d-block fs-7'>
                                        {property.property_account_type_name}
                                      </span>
                                    </td>
                                    <td className='max-w-150px'>
                                      <div className='d-flex flex-shrink-0'>
                                        <Link
                                          to={`/property/${property.property_uuid}/overview`}
                                          className='border-0 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                        >
                                          <i
                                            className='bi bi-eye-fill bi-4x fs-2'
                                            title='View Property'
                                          ></i>
                                        </Link>
                                        <Link
                                          to={`/tenant/${property.property_uuid}?property_id=${property.property_id}&page=1`}
                                          className='border-0 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                        >
                                          <i
                                            className='bi bi-file-earmark-person fs-3'
                                            title='View Tenant'
                                          ></i>
                                        </Link>
                                        <Link
                                          to={`/propertyUsers/${property.property_uuid}?page=1`}
                                          className='border-0 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                        >
                                          <i
                                            className='bi bi-people-fill fs-3'
                                            title='View Property Users'
                                          ></i>
                                        </Link>
                                        {/* /propertyUsers/64770083e48b471185a3eba6fe4dda36?page=1 */}
                                        {/* <button
                                          className='border-0 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                          onClick={() =>
                                            submitTenant(
                                              property.account_role_json,
                                              property.property_title,
                                              property.property_usage_type,
                                              property.sub_unit_available,
                                              property.property_uuid
                                            )
                                          }
                                        >
                                          <i
                                            className='bi bi-file-earmark-person fs-3'
                                            title='View Tenant(s)'
                                          ></i>
                                        </button> */}
                                        {/* <button
                                          className='border-0 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                          onClick={() =>
                                            SubmitPropertyUsers(
                                              property.account_role_json,
                                              property.property_uuid,
                                              property.property_title,
                                              property.property_usage_type,
                                              property.property_id
                                            )
                                          }
                                        >
                                          <i
                                            className='bi bi-people-fill fs-3'
                                            title='Property Users'
                                          ></i>
                                        </button> */}
                                        <Link
                                          to={`/property/rent_info/${property.property_uuid}`}
                                          className='border-0 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                        >
                                          <i
                                            className='bi bi-cash-stack fs-3'
                                            title='Rent info'
                                          ></i>
                                        </Link>
                                        <button
                                          // to={`/property/rent_info/${property.property_uuid}`}
                                          onClick={() => handleWhatsapp(property.property_uuid)}
                                          className='border-0 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                        >
                                          <i className='bi bi-whatsapp fs-3' title='Whatsapp'></i>
                                        </button>
                                        {/* {property.property_account_status === 2 ? (
                                      <button
                                        onClick={() => handleUnBlock(property.property_uuid)}
                                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                      >
                                        <i className='bi bi-check-square fs-3' title='Unblock'></i>
                                      </button>
                                    ) : (
                                      <button
                                        onClick={() => handleBlock(property.property_uuid)}
                                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                      >
                                        <i className='bi bi-x-square fs-3' title='Block'></i>
                                      </button>
                                    )} */}
                                      </div>
                                    </td>
                                  </tr>
                                )
                              })
                            )}
                          </tbody>
                          {/* end::Table body */}
                        </table>
                        {/* end::Table */}
                      </div>
                    </div>
                  </div>
                </div>
                {/* End: Table */}
                {/* Begin: Pagination */}
                {propertyData && pageCount > 1 && (
                  <PaginationComponent
                    itemsPerPage={itemsPerPage}
                    dataLength={dataLength}
                    setItemOffset={setItemOffset}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    pageCount={pageCount}
                  />
                )}
                {/* End: Pagination */}
              </>
            )}
          </>
        </div>
      </div>
      {/* End: property page content */}
    </>
  )
}

export default PropertyNewNewHome
